<template lang="pug">
  include ../../../pug/mixins/bem
  +b.modal.is-opened(
    :class='{"is-trans": inline}'
  )
    +e.A.close(
      href!='', 
      v-if='!inline'
      @click.prevent='$emit("close")', 
    ) &times;
    +e.inner
      +b.form-load(v-if='load')                
        loading
      +e.header(v-if='!inline')
        +e.title {{ _("Авторизация") }}
      +e.content
        form(
          name="enter", 
          @submit.prevent='submit', 
          method='post', 
        )
          .modal__enter
            button.modal__facebook(
              href='',
              @click.prevent='facebookAuth'
            )
              span.modal__facebook--icon
              span.modal__facebook--text {{ _('Войти через Facebook') }}
            .modal__or {{ _('или') }}
            input-group(
              type="text"
              id='username'
              name='username'
              :placeholder='_("Введите адрес электронной почты")'
              v-validate="'required|min:2|max:50|email'"
              v-model="form.username"
            )
            input-group(
              type="text"
              id='phone'
              ref='phone'
              name='phone'
              :placeholder='_("Введите номер телефона")'
              v-validate="'required|phone'"
              v-model="form.phone"
            )
            div(
              style='color: #dd4400', 
              v-if='errors.username'
            ): small(
              v-for='error in errors.username', 
              v-text='error'
            )
            .modal__form-bottom
              button.calendar__link.modal__submit(type="submit") {{ _('Войти') }}
              .modal__rules
                input.modal__check(
                  type="checkbox", 
                  name="rules", 
                  id="rules2", 
                  required='', 
                  v-model='form.can'
                )
                label.modal__label(for="rules2") {{ _('Я даю согласие на использование своих персональных данных') }}
                a.modal__link-rules(:href='policy', target="_blank") {{ _('Политика конфиденциальности') }}
</template>

<script>
import { mapActions } from 'vuex'
import getInfoMixin from './getInfoMixin'
import InputGroup from "./InputGroup"
import { masking } from '@shared/utils/helpers'
import { isIE } from '@calendar/components/stage-selector'
import { default as Api } from '../services/Api'
export default {
  name: 'Login',
  components: {
    InputGroup
  },
  props: {
    inline: {},
    sendInfo: {

    },
  },
  mixins: [ getInfoMixin ],
  data() {
    return { 
      policy: window.policy,
      facebookUrl: window.facebookUrl,
      form: {
        can: false,
        username: '',
        phone: ''
      },
    }
  },
  async mounted() {
    window.isSend = false
    masking('phone', this)
  },
  methods: {
    ...mapActions({
      getSession: 'user/SESSION'
    }),
    facebookAuth() {
      if (isIE) {
        window.location.assign(this.facebookUrl)
        return
      }

      let authWindow = window.open(
        this.facebookUrl,
        'authWindow',
          'height=450, width=550, top='
          + ($(window).height() / 2 - 275)
          + ', left='
          + ($(window).width() / 2 - 225)
          + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
      )

      let receiver = (...attrs) => {
        let host = ''
        try { host = authWindow.location.host } catch(e) {}
        if (host == window.location.host) {
          this.getSession()
            .then(async session => {
              this.$emit('close')

              this.resolve(session)
              if (this.sendInfo) {
                this.load = true
                window.isSend = true
                await this.receiveInfo(session.email, true)
                this.load = false
                window.location.reload()
              } else {
                window.location.reload()

              }
            })
          authWindow.close()

          return
        }

        setTimeout(receiver, 100)
      }
      receiver()
    },
    resolve() {},
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.load = true
          let formdata = new FormData()
          Object.keys(this.form).forEach( key => {
            formdata.append(key, this.form[key])
          })
          if (this.sendInfo) {
            formdata.append('sendCalendar', true)

          }
          Api().post(window.auth_url, formdata)
            .then(async res => {
              this.load = false
              this.$emit('close')
              this.$validator.reset()
              if (this.sendInfo) {
                this.load = true
                window.isSend = true
                await this.receiveInfo(this.form.username)
                this.load = false
              }
              window.location.reload()
            }, err => {
              this.load = false
              this.$emit('close')
            })
        }
      })
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/Login.vue